import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import ApiKeyDisplay from '../api-key-display';
type CreateOrgApiKeyProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const CreateOrgApiKey = t0 => {
  const $ = _c(13);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.apiKeys"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "create_org_api_key") {
    return null;
  }
  const {
    apiKey: t2
  } = detail.data;
  const {
    name,
    role: t3
  } = t2;
  const {
    scopes,
    name: roleName
  } = t3;
  let t4;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t4 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <span className="text-body-2 text-tertiary">{t4}</span>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== name || $[7] !== roleName || $[8] !== scopes) {
    t6 = <ApiKeyDisplay name={name} scopes={scopes} roleName={roleName} />;
    $[6] = name;
    $[7] = roleName;
    $[8] = scopes;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default CreateOrgApiKey;
function _temp($) {
  return $.createdANew;
}
function _temp2($_0) {
  return $_0.createdANew;
}